import axios from 'axios';
import { Message } from 'element-ui'; // 引入 Element UI 的 Message 组件

// 基本配置
const request = axios.create({
  //有两个地方有baseUrl
  baseURL: 'https://www.xiaoxiansheng.vip/admin_server',
  // baseURL: "http://2cq3eod.nat.ipyingshe.com/admin_server",
  // baseURL: "http://127.0.0.1:8080/admin_server",
  // baseURL: 'http://119.29.41.192:8080',npm
  //服务器地址
  timeout: 8000 // 设置超时时间，单位为 ms
});

// 请求拦截器
request.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['token'] = token; // 使用 'token' 字段而非 'Authorization'
  }
  return config;
}, error => {
  console.error('请求错误:', error); // 修改日志输出方式
  return Promise.reject(error);
});

// 响应拦截器
request.interceptors.response.use(response => {
  const status = response.status;

  if (status === 400) {
    // 处理 400 错误
    const errorMsg = response.data.message || '请求参数错误，请检查并重试。';

    if (errorMsg.includes('分页') || errorMsg.includes('筛选')) {
      Message.error('查询参数有误，请检查分页或筛选条件的合法性。');
    } else if (errorMsg.includes('订单更新失败')) {
      Message.error('订单内容有误，请检查订单内容。');
    } else if (errorMsg.includes('订单ID')) {
      Message.error('订单ID不能为空，请检查订单ID。');
    } else if (errorMsg.includes('文件为空') || errorMsg.includes('上传失败')) {
      Message.error('文件为空或上传失败，请重新上传文件。');
    } else {
      Message.error(`错误: ${errorMsg}`);
    }
    return Promise.reject(new Error(errorMsg));
  }

  if (status === 401) {
    // 处理 401 错误
    Message.error('Token 失效，请重新登录。');
    localStorage.removeItem('token');
    window.location.href = '/login'; // 或使用 this.$router.push('/login') 如果在组件中
    return Promise.reject(new Error('Token 失效'));
  }

  if (status === 402) {
    // 处理 402 错误
    Message.error('用户未登录，请登录后再试。');
    localStorage.removeItem('token');
    window.location.href = '/login'; // 或使用 this.$router.push('/login') 如果在组件中
    return Promise.reject(new Error('用户未登录'));
  }

  if (status === 403) {
    // 处理 403 错误
    Message.error('未授权访问，请登录后再试。');
    localStorage.removeItem('token');
    window.location.href = '/login'; // 或使用 this.$router.push('/login') 如果在组件中
    return Promise.reject(new Error('未授权访问'));
  }

  if (status === 404) {
    // 处理 404 错误
    const errorMsg = response.data.message || '请求的资源未找到。';

    if (errorMsg.includes('未找到对应ID')) {
      Message.error('未找到对应ID的订单。');
    } else if (errorMsg.includes('文件不存在')) {
      Message.error('文件不存在。');
    } else {
      Message.error(`错误: ${errorMsg}`);
    }
    return Promise.reject(new Error(errorMsg));
  }

  if (status === 500) {
    // 处理 500 错误
    Message.error('服务器异常，请稍后重试。');
    return Promise.reject(new Error('服务器异常'));
  }

  // 返回成功的响应数据
  return response.data;
}, error => {
  if (error.response) {
    const status = error.response.status;
    const errMsg = error.response.data.message || '请求失败，请稍后重试。';

    if (status === 500) {
      Message.error('服务器异常，请稍后重试。');
    } else if (status === 403) {
      Message.error('未授权访问，请登录后再试。');
      localStorage.removeItem('token');
      window.location.href = '/login'; // 或使用 this.$router.push('/login') 如果在组件中
    } else if (status === 401) {
      Message.error('Token 失效，请重新登录。');
      localStorage.removeItem('token');
      window.location.href = '/login'; // 或使用 this.$router.push('/login') 如果在组件中
    } else if (status === 402) {
      Message.error('用户未登录，请登录后再试。');
      localStorage.removeItem('token');
      window.location.href = '/login'; // 或使用 this.$router.push('/login') 如果在组件中
    } else if (status === 400) {
      const errorMsg = error.response.data.message || '请求参数错误，请检查并重试。';

      if (errorMsg.includes('分页') || errorMsg.includes('筛选')) {
        Message.error('查询参数有误，请检查分页或筛选条件的合法性。');
      } else if (errorMsg.includes('订单更新失败')) {
        Message.error('订单内容有误，请检查订单内容。');
      } else if (errorMsg.includes('订单ID')) {
        Message.error('订单ID不能为空，请检查订单ID。');
      } else if (errorMsg.includes('文件为空') || errorMsg.includes('上传失败')) {
        Message.error('文件为空或上传失败，请重新上传文件。');
      } else {
        Message.error(`错误: ${errorMsg}`);
      }
    } else if (status === 404) {
      const errorMsg = error.response.data.message || '请求的资源未找到。';

      if (errorMsg.includes('未找到对应ID')) {
        Message.error('未找到对应ID的订单。');
      } else if (errorMsg.includes('文件不存在')) {
        Message.error('文件不存在。');
      } else {
        Message.error(`错误: ${errorMsg}`);
      }
    } else {
      Message.error(`错误: ${errMsg}`);
    }
  } else {
    // 网络错误或其他非响应错误
    Message.error('连接服务器失败，请检查您的网络连接。');
  }

  console.error('响应错误:', error); // 修改日志输出方式
  return Promise.reject(error);
});

export default request;
